import { RouteObject } from "react-router-dom";
import { BioMetricGuard } from "../../routes/Guards/BioMetricGuard";
import { R_HomeRoutes } from "../../utils/Routes";
import { lazy } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";
const Dashboard = lazy(() => import("./Dashboard"));
const NoHoldingsFound = lazy(
  () => import("../NoHoldingsFoundPage/NoHoldingsFound")
);
const HomeRoutes: RouteObject[] = [
  {
    path: R_HomeRoutes.home,
    element: <BioMetricGuard />,
    children: [
      {
        path: "/home",
        element: <SuspenseWrapper LazyLoadingComponent={Dashboard} />,
      },
    ],
  },
  {
    path: R_HomeRoutes.noHoldings,
    element: <SuspenseWrapper LazyLoadingComponent={NoHoldingsFound} />,
  },
];

export default HomeRoutes;
